export default {"src":"/_next/static/media/icon_letter1.b99b1f61.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};